// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2_tDJ","validationTips":"StatementDescriptor_validationTips__u3L-b"};